import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const AudienceType = iotsUtils.fromList(constants.transaction.review.audienceTypes);
